var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("registration-form", {
    attrs: {
      alert: _vm.alert,
      "privacy-policy-url": _vm.privacyPolicyUrl,
      additionalFields: _vm.additionalFields,
    },
    on: { submit: _vm.submit },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }